import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export type LightboxState = {
    open: boolean;
    emoji: string;
    gif: string;
    openGif: boolean;
    openEmoji: boolean;
};

const initialState: LightboxState = {
    open: false,
    emoji: "",
    gif: "",
    openGif: false,
    openEmoji: false
};

export const lightboxSlice = createSlice({
    name: "lightbox",
    initialState,
    reducers: {
        openLightBox: (state) => {
            state.open = true;
        },
        closeLightBox: (state) => {
            state.open = false;
        },
        setEmoji: (state, action: PayloadAction<string>) => {
            state.emoji = action.payload;
            state.openEmoji = false;
        },
        setGif: (state, action: PayloadAction<string>) => {
            state.gif = action.payload;
            state.openGif = false;
        },
        openGifModal: (state) => {
            state.openGif = true;
        },
        closeGifModal: (state) => {
            state.openGif = false;
        },
        openEmojiModal: (state) => {
            state.openEmoji = true;
        },
        closeEmojiodal: (state) => {
            state.openEmoji = false;
        }
    }
});

export const {
    openLightBox,
    closeLightBox,
    setEmoji,
    setGif,
    openGifModal,
    closeGifModal,
    closeEmojiodal,
    openEmojiModal
} = lightboxSlice.actions;

export default lightboxSlice.reducer;
